import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

// Dark navy hero band used across content pages. Includes breadcrumb.
export function PageHero({ eyebrow, title, subtitle, crumbs = [], children }) {
  return (
    <section className="relative bg-navy-deep text-warm overflow-hidden pt-36 pb-20 md:pt-44 md:pb-24">
      <div className="spotlight absolute inset-0 pointer-events-none" />
      <div className="max-w-5xl mx-auto px-6 md:px-8 relative">
        {crumbs.length > 0 && (
          <nav className="flex items-center gap-1.5 text-xs text-warm/45 mb-8 flex-wrap" aria-label="Breadcrumb">
            <Link to="/" className="hover:text-gold">Home</Link>
            {crumbs.map((c, i) => (
              <span key={i} className="flex items-center gap-1.5">
                <ChevronRight className="h-3 w-3" />
                {c.to ? <Link to={c.to} className="hover:text-gold">{c.label}</Link> : <span className="text-warm/70">{c.label}</span>}
              </span>
            ))}
          </nav>
        )}
        {eyebrow && <p className="accent-eyebrow text-gold">{eyebrow}</p>}
        <h1 className="font-playfair text-4xl md:text-6xl mt-5 leading-[1.05] tracking-tight">{title}</h1>
        {subtitle && <p className="text-warm/60 text-lg md:text-xl mt-6 max-w-2xl leading-relaxed">{subtitle}</p>}
        {children}
      </div>
    </section>
  );
}
